import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteCategoryTypeArguments {
  params: OpalApiRequestParams<'DeleteCategoryTypeV3'>
}

export async function deleteCategoryType({
  params,
}: DeleteCategoryTypeArguments): Promise<null> {
  const url = new URL(
    `/loupe/v3/category_types/${params.path.category_type_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
